import axios from "axios"
import { useRouter } from "next/router"
import React, { useState } from "react"
import { useForm } from "react-hook-form"
import { Preloader } from "../universal/preloader"

type Props = {}

interface IInput {
  name: string
  email: string
  subject: string
  body: string
}

export const GeneralForm: React.FC<Props> = () => {
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IInput>()

  const onSUbmit = (data: IInput) => {
    const postData = {
      ...data,
      type: "general",
    }

    setLoading(true)
    axios
      .post("/api/contact", postData)
      .then((res) => {
        if (res.status == 200) {
          router.push("/contact/success")
        } else {
          router.push("/contact/error")
        }
      })
      .catch((err) => {
        setLoading(false)
        router.push("/contact/error")
      })
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit(onSUbmit)}>
      <label>your name {errors.name && <small className="error">(Required!)</small>}</label>
      <input type="text" required {...register("name", { required: true })} placeholder="Enter your name" />

      <label>email {errors.email && <small className="error">(Required!)</small>}</label>
      <input type="text" required {...register("email", { required: true })} placeholder="address@email.com" />

      <label>Subject {errors.subject && <small className="error">(Required!)</small>}</label>
      <input type="text" required {...register("subject", { required: true })} placeholder="Write a subject" />

      <label>Message {errors.body && <small className="error">(Required!)</small>}</label>
      <textarea placeholder="Write your message" required {...register("body", { required: true })} className="input-text message-input" />

      <button type="submit" className="btn-lg-label bg-primary secondary">
        Submit
        {loading && <Preloader color="white" />}
      </button>
    </form>
  )
}
